export function formatDate(timestamp: Date | string | number): string {
  return new Date(timestamp).toDateString();
}
